module.exports = __webpack_public_path__ + "img/我们为社会带来了什么.3130c623.png";